module.exports = __webpack_public_path__ + "static/img/pic-avatar-vip1.32b397e.png";